// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { AngleMeasurement } from './angle-measurement';
import { Circle } from './circle';
import { DistanceMeasurement } from './distance-measurement';
import { Image } from './image';
import { Line } from './line';
import { Mesh } from './mesh';
import { Plane } from './plane';
import { Point } from './point';
import { Sphere } from './sphere';
import { Spline } from './spline';
import { Units } from './units';


export class MCSData {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):MCSData {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsMCSData(bb:flatbuffers.ByteBuffer, obj?:MCSData):MCSData {
  return (obj || new MCSData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsMCSData(bb:flatbuffers.ByteBuffer, obj?:MCSData):MCSData {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new MCSData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static bufferHasIdentifier(bb:flatbuffers.ByteBuffer):boolean {
  return bb.__has_identifier('MCSD');
}

images(index: number, obj?:Image):Image|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new Image()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

imagesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

meshes(index: number, obj?:Mesh):Mesh|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new Mesh()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

meshesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

activeImageGuid():string|null
activeImageGuid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
activeImageGuid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

projectUnits():Units {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : Units.Millimeters;
}

points(index: number, obj?:Point):Point|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new Point()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

pointsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

lines(index: number, obj?:Line):Line|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new Line()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

linesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

circles(index: number, obj?:Circle):Circle|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new Circle()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

circlesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

spheres(index: number, obj?:Sphere):Sphere|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? (obj || new Sphere()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

spheresLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

planes(index: number, obj?:Plane):Plane|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new Plane()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

planesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

splines(index: number, obj?:Spline):Spline|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? (obj || new Spline()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

splinesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

distanceMeasurements(index: number, obj?:DistanceMeasurement):DistanceMeasurement|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? (obj || new DistanceMeasurement()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

distanceMeasurementsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

angleMeasurements(index: number, obj?:AngleMeasurement):AngleMeasurement|null {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? (obj || new AngleMeasurement()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

angleMeasurementsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startMCSData(builder:flatbuffers.Builder) {
  builder.startObject(12);
}

static addImages(builder:flatbuffers.Builder, imagesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, imagesOffset, 0);
}

static createImagesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startImagesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addMeshes(builder:flatbuffers.Builder, meshesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, meshesOffset, 0);
}

static createMeshesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startMeshesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addActiveImageGuid(builder:flatbuffers.Builder, activeImageGuidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, activeImageGuidOffset, 0);
}

static addProjectUnits(builder:flatbuffers.Builder, projectUnits:Units) {
  builder.addFieldInt8(3, projectUnits, Units.Millimeters);
}

static addPoints(builder:flatbuffers.Builder, pointsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, pointsOffset, 0);
}

static createPointsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startPointsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addLines(builder:flatbuffers.Builder, linesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, linesOffset, 0);
}

static createLinesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startLinesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addCircles(builder:flatbuffers.Builder, circlesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, circlesOffset, 0);
}

static createCirclesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startCirclesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addSpheres(builder:flatbuffers.Builder, spheresOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, spheresOffset, 0);
}

static createSpheresVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startSpheresVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addPlanes(builder:flatbuffers.Builder, planesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, planesOffset, 0);
}

static createPlanesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startPlanesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addSplines(builder:flatbuffers.Builder, splinesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, splinesOffset, 0);
}

static createSplinesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startSplinesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addDistanceMeasurements(builder:flatbuffers.Builder, distanceMeasurementsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(10, distanceMeasurementsOffset, 0);
}

static createDistanceMeasurementsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startDistanceMeasurementsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addAngleMeasurements(builder:flatbuffers.Builder, angleMeasurementsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(11, angleMeasurementsOffset, 0);
}

static createAngleMeasurementsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startAngleMeasurementsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endMCSData(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static finishMCSDataBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, 'MCSD');
}

static finishSizePrefixedMCSDataBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, 'MCSD', true);
}

static createMCSData(builder:flatbuffers.Builder, imagesOffset:flatbuffers.Offset, meshesOffset:flatbuffers.Offset, activeImageGuidOffset:flatbuffers.Offset, projectUnits:Units, pointsOffset:flatbuffers.Offset, linesOffset:flatbuffers.Offset, circlesOffset:flatbuffers.Offset, spheresOffset:flatbuffers.Offset, planesOffset:flatbuffers.Offset, splinesOffset:flatbuffers.Offset, distanceMeasurementsOffset:flatbuffers.Offset, angleMeasurementsOffset:flatbuffers.Offset):flatbuffers.Offset {
  MCSData.startMCSData(builder);
  MCSData.addImages(builder, imagesOffset);
  MCSData.addMeshes(builder, meshesOffset);
  MCSData.addActiveImageGuid(builder, activeImageGuidOffset);
  MCSData.addProjectUnits(builder, projectUnits);
  MCSData.addPoints(builder, pointsOffset);
  MCSData.addLines(builder, linesOffset);
  MCSData.addCircles(builder, circlesOffset);
  MCSData.addSpheres(builder, spheresOffset);
  MCSData.addPlanes(builder, planesOffset);
  MCSData.addSplines(builder, splinesOffset);
  MCSData.addDistanceMeasurements(builder, distanceMeasurementsOffset);
  MCSData.addAngleMeasurements(builder, angleMeasurementsOffset);
  return MCSData.endMCSData(builder);
}
}
